import type { AccountMetricsFetchedAction } from '@Application/AccountMetrics/Actions/accountMetricsFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import AccountMetricsView from '@UI/Store/AccountMetrics/Views/AccountMetricsView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AccountMetricsStore = {
	accountMetrics: AccountMetricsView | null;
};

const initialState: AccountMetricsStore = {
	accountMetrics: null,
};

type Actions = AccountMetricsFetchedAction | UserRevokedAction;

const whenAccountMetricsFetched = (
	store: AccountMetricsStore,
	action: AccountMetricsFetchedAction,
): AccountMetricsStore => ({
	...store,
	accountMetrics: new AccountMetricsView(action.payload),
});

const whenUserRevoked = (): AccountMetricsStore => initialState;

export default registerStore<'accountMetricsStore', Actions>(
	'accountMetricsStore',
	createSliceReducer({
		ACCOUNT_METRICS_FETCHED: whenAccountMetricsFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
